import React, { Component } from "react"
const video = require('../video/test.mp4')
class Webcam extends Component {
    constructor(props) {
        super(props)

        this.state = {}

        this.vid = null
        this.stream = null

        this.init = this.init.bind(this)
        this.camSuccess = this.camSuccess.bind(this)
        this.camFail = this.camFail.bind(this)
    }

    componentDidMount() {
        this.init()
    }

    init() {
        //const {videoID} = this.props
        //console.log("videoID")
        //this.vid = document.getElementById(videoID);
        this.vid = this.refs.video
        //this.vid.addEventListener('canplay', this.enablestart, false);

        navigator.getUserMedia =
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia
        window.URL =
            window.URL || window.webkitURL || window.msURL || window.mozURL

        // check for camerasupport
        if (navigator.mediaDevices) {
            navigator.mediaDevices
                .getUserMedia({ video: true })
                .then(this.camSuccess)
                .catch(this.camFail)
        } else if (navigator.getUserMedia) {
            navigator.getUserMedia(
                { video: true },
                this.camSuccess,
                this.camFail
            )
        } else {
            alert(
                "This demo depends on getUserMedia, which your browser does not seem to support. :("
            )
        }
    }

    camFail(err) {
        //alert("Scared of NSA?");
        console.log(err)
    }
    camSuccess(stream) {
        this.stream = stream

        // add camera stream if getUserMedia succeeded
        if ("srcObject" in this.vid) {
            this.vid.srcObject = stream
        } else {
            this.vid.src = window.URL && window.URL.createObjectURL(stream)
        }
        this.vid.onloadedmetadata = function() {
            //console.log("loaded")
            //adjustVideoProportions();
            //this.vid.play();
        }
    }

    render() {
        return (
            <div className="video-wrapper">
                <video autoPlay ref="video" src={""} />
            </div>
        )
    }
}

export default Webcam
